module.exports = __webpack_public_path__ + "img/search.0397e55f.png";